<label
  class="upload-logo"
  [for]="id"
  [ngClass]="{
    empty: !fileName,
    uploaded: fileName,
    'is-drag-over': isDragOver,
    'has-error': fileControl.invalid
  }"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  (dragleave)="onDragLeave($event)"
>
  <span class="upload-logo-body">
    <img class="upload-logo-body-icon" alt="add" src="/assets/icons/icon_click_add.svg" />
    <span class="upload-logo-body-text">{{ "UPLOAD_LOGO" | translate }}</span>

    <loading-spinner [show]="isLoading || isUploadingDoc"></loading-spinner>
  </span>
</label>

<div class="upload-logo-errors" *ngIf="fileControl.invalid">
  <app-control-errors [errors]="errors" [control]="fileControl" [isShowHelper]="false"></app-control-errors>
</div>

<input
  #inputElement
  class="d-none"
  type="file"
  [id]="id"
  [accept]="ALLOWED_FILE_MIMES.join(',')"
  (click)="clickInput()"
  (change)="handleFiles($event)"
  [disabled]="!!fileName"
/>
